module.exports = "/fonts/vendor/@fontsource/roboto/files/roboto-greek-500-normal.woff2?9ac81fefbe6c319ea40be5069cbf2b53";